import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useContext } from 'react';
import { Box, Copy, Pill, Optional, Icon } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import Link from '../../RoutableSitecoreLink';
import { HONDA_SITE_NAME, ACURA_SITE_NAME } from '../../../utils/constants';
import { useAppName } from '../../../utils/sitecoreContext';
import HeaderContext from '../service/HeaderContext';
import themeStyles from '../styles/DealerStatusAndHours.styles';
import useDealerStatusAndHours from '../service/useDealerStatusAndHours';
import { pushDealerGtmEvent } from '../../../utils/gtmEvents';
const DealerHoursContainer = themeStyles.apply(Box, 'DealerHoursContainer');
const DealerHoursRow = themeStyles.apply(Box, 'DealerHoursRow');
const DealerHoursDescription = themeStyles.apply(Copy, 'DealerHoursDescription');
const DealerLabel = themeStyles.apply(Copy, 'DealerLabel');
const DealerName = themeStyles.apply(Link, 'DealerName');
const DealerStatusAndHours = ({ link }) => {
    // @ts-ignore
    const appName = useAppName();
    const { t } = useTranslation();
    const { dealerName, isDealerOpen, message, isHoursUnavailable } = useDealerStatusAndHours();
    const headerContext = useContext(HeaderContext);
    const { styles } = headerContext;
    if (!message || !dealerName)
        return null;
    const pillStatus = isDealerOpen
        ? { pillLabel: t('Shared.Common.openLabel'), pillType: 'Success' }
        : { pillLabel: t('Shared.Common.closedLabel'), pillType: 'Danger' };
    let pillHasBackground;
    switch (appName) {
        case HONDA_SITE_NAME:
            break;
        case ACURA_SITE_NAME:
            pillHasBackground = false;
            break;
        default:
            break;
    }
    const gtmOnClickHandler = () => {
        pushDealerGtmEvent({
            dealerName,
            linkText: 'dealer',
        });
    };
    return (_jsxs(DealerHoursContainer, { children: [_jsxs(DealerHoursRow, { pl: "xxs", children: [_jsx(DealerLabel, { size: "extraSmall", variant: appName, as: Link, field: link, onClick: () => gtmOnClickHandler(), children: t('Shared.Common.dealerLabel') }), _jsx(DealerName, { field: link, "data-testid": "cy-current-dealer-name", variant: appName, onClick: () => gtmOnClickHandler(), children: dealerName })] }), _jsxs(DealerHoursRow, { children: [_jsxs(Optional, { when: !isHoursUnavailable, children: [_jsx(Pill, { pillLabel: pillStatus.pillLabel, pillType: pillStatus.pillType, mr: "xxs", "data-testid": "cy-current-dealer-status", hasBackground: pillHasBackground, fontFamily: styles.pill.dealerStatusFontFamily }), _jsx(DealerHoursDescription, { "data-testid": "cy-current-dealer-hour", variant: appName, children: message })] }), _jsxs(Optional, { when: isHoursUnavailable, children: [_jsx(Icon, { name: "information", mx: "xxs" }), _jsx(DealerHoursDescription, { "data-testid": "cy-current-dealer-hour", variant: appName, children: message })] })] })] }));
};
export default DealerStatusAndHours;
